import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { useTranslate } from 'react-admin';

import { TypographyTranslated } from '@sh4res/bo-common/components';
import { PageTitle } from '@sh4res/bo-common/components/PageTitle';

import { AxaTypography } from '@Components/AxaTypography';
import { TranslationKeys } from '@I18n/types';

const EmailIconSvg = styled('svg')`
  margin-top: 40px;
`;

type EmailIconProps = { width?: string; height?: string };
const EmailIcon = ({ width = '70', height = '52' }: EmailIconProps) => (
  <EmailIconSvg
    width={width}
    height={height}
    viewBox="0 0 70 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M50 0C59.4281 0 64.1424 -0.000221252 67.0713 2.92871C70.0002 5.85764 70 10.5719 70 20V32C70 41.4281 70.0002 46.1424 67.0713 49.0713C64.1424 52.0002 59.4281 52 50 52H20C10.5719 52 5.85764 52.0002 2.92871 49.0713C-0.000221252 46.1424 0 41.4281 0 32V20C0 10.5719 -0.000221252 5.85764 2.92871 2.92871C5.85764 -0.000221252 10.5719 0 20 0H50ZM60.7393 10.0186C59.8204 8.69171 58.0125 8.35664 56.6855 9.26074L37.4795 22.458C35.992 23.4788 34.008 23.4788 32.5205 22.458L13.3145 9.26074C11.9875 8.35664 10.1796 8.69171 9.26074 10.0186C8.35658 11.3456 8.69147 13.1545 10.0186 14.0732L29.21 27.2705C30.9454 28.4663 32.9729 29.0498 35 29.0498C37.0271 29.0498 39.0546 28.4663 40.79 27.2705L59.9814 14.0732C61.3085 13.1545 61.6434 11.3456 60.7393 10.0186Z"
      fill="#B8B8B8"
    />
  </EmailIconSvg>
);

type VerifyEmailPageProps = {
  header: TranslationKeys;
  subheader: TranslationKeys;
  note?: TranslationKeys;
  headerVariables?: Record<string, string>;
  subheaderVariables?: Record<string, string>;
  noteVariables?: Record<string, string>;
};

export function VerifyEmailPageSuccess({
  header,
  subheader,
  note,
  headerVariables,
  subheaderVariables,
  noteVariables,
}: VerifyEmailPageProps) {
  const translate = useTranslate();

  return (
    <>
      <PageTitle title={translate(header)} />
      <Box sx={{ textAlign: 'center' }}>
        <EmailIcon />
        <TypographyTranslated
          component={AxaTypography}
          label={header}
          variables={headerVariables}
          variant="h5"
          textAlign="center"
          sx={{ mt: '32px', fontWidth: 700 }}
        />
        <TypographyTranslated
          label={subheader}
          variables={subheaderVariables}
          variant="body1"
          textAlign="center"
          sx={{ my: '16px', whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}
        />
        {note && (
          <TypographyTranslated
            label={note}
            variables={noteVariables}
            variant="body2"
            textAlign="center"
            sx={{ mb: '24px' }}
          />
        )}
      </Box>
    </>
  );
}
